export default {
  TITLE: `Mes paramètres`,
  COLOR_NORMAL: `Standard`,
  COLOR_HIGH_CONTRAST: `Haut-contraste`,
  COLOR_ICONS: `Standard + Icônes`,
  SCHEDULER_OPTIONS: `Options du module d'horaire :`,
  SCHEDULER_COLORS: `Couleurs dans le module d'horaire :`,
  OTHER_OPTIONS: `Autres options :`,
  SHOW: `Afficher à nouveau`,
  HELP_CARD_DISMISS_MSG: `Vous avez caché certaines cartes d'aide. Souhaitez-vous les afficher à nouveau?`,
  HELP_CARD_ALL_SHOWED_MSG: `Toutes les cartes d'aide sont montrées actuellement.`,
  SCHEDULEEDGESCROLLING: {
    LABEL: `Défilement des bords`,
    PLACEHOLDER: ``,
    DESCRIPTION: `Permet de faire défiler la vue de l'horaire en déplaçant la souris sur les bords de la fenêtre de l'horaire.`
  },
  GROUPSCHEDULEEVENTS: {
    LABEL: `Regroupement des quarts de travail`,
    PLACEHOLDER: ``,
    DESCRIPTION: `Permet de regrouper les quarts de travail qui se chevauchent et qui sont à la même position.`
  },
  SCHEDULEREVENTSHIGHCONTRAST: {
    LABEL: `Mode haut contraste`,
    PLACEHOLDER: ``,
    DESCRIPTION: `Change les couleurs des quarts de travail dans l'horaire pour accentuer le contraste et les différences entre les couleurs.`
  },
  ENABLEDATEPICKERMANUALINPUT: {
    LABEL: `Entrée manuelle des dates/heures`,
    PLACEHOLDER: ``,
    DESCRIPTION: `Activer l'entrée manuelle des dates et heures dans le logiciel, ceci augmentera le nombre de clics requis pour naviguer les sélecteurs de dates.`
  },
  CSVDELIMITER: {
    LABEL: `Séparateur CSV`,
    PLACEHOLDER: ``,
    DESCRIPTION: `Le caractère à utiliser lors de la séparation des données dans un CSV (Excel en français utilise ";").`
  }
}
